import type { SVGProps } from "react";
export interface HeadHeartIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HeadHeartIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HeadHeartIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M12.457 5.875c.936 0 1.747.48 2.29 1.102a3.52 3.52 0 0 1 .873 2.408l.002.001c-.037 1.226-.758 2.166-1.42 2.852l-.278.28c-.49.48-.96.924-1.365 1.3l-.98.897a1.615 1.615 0 0 1-2.04.098l-.118-.098a75 75 0 0 1-1.633-1.508l-.715-.689c-.719-.703-1.656-1.73-1.698-3.132l.001-.001a3.53 3.53 0 0 1 .875-2.408c.543-.623 1.353-1.102 2.288-1.102.866 0 1.5.308 1.959.688.458-.38 1.093-.688 1.96-.688Zm0 2.25c-.293 0-.459.102-.587.229a1.4 1.4 0 0 0-.202.26l-.157.295v.001l-.028.05-.022.04a1 1 0 0 1-.174.216 1.1 1.1 0 0 1-.299.217 1.1 1.1 0 0 1-.38.103 1.1 1.1 0 0 1-.32-.015 1 1 0 0 1-.157-.038q-.003 0-.005-.002a1 1 0 0 1-.118-.048q-.03-.015-.061-.034l-.022-.011a1 1 0 0 1-.213-.169 1.1 1.1 0 0 1-.178-.221l-.02-.04q-.016-.023-.027-.048l-.002-.001c-.097-.203-.2-.4-.357-.555-.128-.127-.295-.229-.589-.229-.148 0-.377.084-.593.331a1.3 1.3 0 0 0-.32.747l-.002.113v.003l.019.161c.073.38.372.813 1.003 1.43l.693.668c.439.417.84.784 1.159 1.075a74 74 0 0 0 1.853-1.743l.25-.254c.539-.567.761-.969.772-1.337v-.003l-.003-.113a1.3 1.3 0 0 0-.32-.747c-.215-.247-.445-.331-.593-.331"
      />
      <path
        fill={color}
        d="M2.875 22v-3.81c0-.863-.331-1.396-.882-2.505C1.446 14.585.875 13.207.875 11 .875 5.14 5.141.875 11 .875c4.878 0 8.384 3.602 9.519 7.945l.364 1.396c.365 1.353.758 2.573 1.442 3.642l.414.646.088.15c.85 1.548-.193 3.496-1.995 3.609l-.813.05-.212 2.014a3.124 3.124 0 0 1-3.107 2.797H14A4.125 4.125 0 0 1 9.875 19a1.125 1.125 0 0 1 2.25 0c0 1.035.84 1.875 1.875 1.875h2.7a.875.875 0 0 0 .87-.783l.223-2.12.029-.19a2.125 2.125 0 0 1 1.95-1.708l.92-.057.052-.01a.196.196 0 0 0 .122-.242l-.022-.048-.415-.646c-1.147-1.794-1.622-3.9-2.087-5.68-.943-3.608-3.728-6.266-7.342-6.266-4.617 0-7.875 3.258-7.875 7.875 0 1.745.429 2.772.882 3.684.449.903 1.118 1.99 1.118 3.507V22a1.125 1.125 0 0 1-2.25 0"
      />
    </svg>
  );
}
